import { camelToSnake } from "utils/caseConvertor";

interface WidgetTitles {
  [key: string]: string;
}

const originalWidgetTitles: WidgetTitles = {
  totalCounts:
    "This widget will display six relevant key performance indicators (KPIs); number of observation, number of forms, number of species observed, number of active users, number of participating communities, number of active programs.",
  qaProgress:
    "Shows the percentage of observations in the quality assurance process: unassigned, in review, or completed.",
  activeUsers:
    "Lists the top five users connected to your network who have made the most observations.",
  notifications:
    "Shows your four most recent notifications. Each card includes the sender’s photo (if available), the date, and the message.",
  qaNotifications:
    "Shows your four most recent quality assurance updates, such as edits made by observers, new observations to review, or edit requests.",
  reportNotifications:
    "Shows your four most recent report updates, including processing, settings, downloads, and shared reports.",
  observationsByLocation:
    "Shows where observations were made by location on a map, if the observation contained GPS coordinates. Circles group nearby points, and you can zoom in to see more detail.",
  observationsByRegion:
    "Shows the six areas where the most observations were recorded.",
  observations:
    "Shows the number of observations recorded in each reporting period (day, week, month, or year). The reporting period can be adjusted in the top-right corner",
  cumulativeObservations:
    "Shows the cumulative number of observations with status In Review or Complete.",
  mostObservedObjects:
    "Shows the top five most frequently observed objects based on reviewed and completed observations.",
  mostObservedSpecies:
    "Displays the top five species observed in In Review and Complete observations only.",
  form: "Shows the percentage of observations from the top five data collection forms used.",
  program:
    "Shows the percentage of observations from the top five contributing programs.",
  community:
    "Shows the percentage of observations from the top five contributing communities connected to your network.",
};

// Convert keys to snake_case using Object.fromEntries and map
const widgetTitles: WidgetTitles = Object.fromEntries(
  Object.entries(originalWidgetTitles).map(([key, value]) => [
    camelToSnake(key),
    value,
  ])
);

export { widgetTitles };
